import React, { useCallback, useEffect, useState } from 'react'
import TextField from '../../../../core/common/textFields/TextField'
import { useLazyGetLocationDetailsByAggressQuery, useLazyGetLocationQuery } from '../../../../services/EndPointsApis';
import { debounce } from 'lodash';

const AddressesWizardData = ({ formik, adressConfirm, setAdressConfirm }: any) => {
    const [searchStr, setSearchStr] = useState('');
    const [immediateSearchStr1, setImmediateSearchStr1] = useState('');
    const [immediateSearchStr2, setImmediateSearchStr2] = useState('');

    const [triggerLocation, { data: locationData }] = useLazyGetLocationQuery();
    const [triggerLocation2, { data: locationData2 }] = useLazyGetLocationQuery();

      // addresses api for longitude and latitude 
        const [triggerLongLatM, { data: longLatDataM }] = useLazyGetLocationDetailsByAggressQuery();
        // addresses api for longitude and latitude 
        const [triggerLongLatP, { data: longLatDataP }] = useLazyGetLocationDetailsByAggressQuery();

    const handleSearchChange1 = (e: any) => {
        const { value } = e.target;
        setImmediateSearchStr1(value);
        delayedSearch1(value);
        formik.setFieldValue("primaryContactVMs.mailingAddress.zipCode", value)
    }
    const handleSearchChange2 = (e: any) => {
        const { value } = e.target;
        setImmediateSearchStr2(value);
        delayedSearch2(value);
        formik.setFieldValue("primaryContactVMs.propertyAddress.zipCode", value)
    }
    const delayedSearch1 = useCallback(
        debounce((searchValue) => {
            setSearchStr(searchValue);
            triggerLocation({ ZipCode: searchValue ||null })
        }, 1000),
        []
    );
    const delayedSearch2 = useCallback(
        debounce((searchValue) => {
            setSearchStr(searchValue);
            triggerLocation2({ ZipCode: searchValue ||null })
        }, 1000),
        []
    );

        // handle search for latlong 
        const handleSearchLongLat1 = (e: any) => {
            const { value } = e.target;
            setImmediateSearchStr2(value);
            delayedSearchLongLat1(value);
            formik.setFieldValue("primaryContactVMs.mailingAddress.addressLine1", value)
        }
        // handle search for latlong 
        const handleSearchLongLat2 = (e: any) => {
            const { value } = e.target;
            setImmediateSearchStr2(value);
            delayedSearchLongLat2(value);
            formik.setFieldValue("primaryContactVMs.propertyAddress.addressLine1", value)
        }

     //debounce for longLat
        const delayedSearchLongLat1 = useCallback(
            debounce((searchValue) => {
                setSearchStr(searchValue);
                triggerLongLatM({ ZipCode: searchValue || null })
            }, 1000),
            []
        );
        //debounce for longLat
        const delayedSearchLongLat2 = useCallback(
            debounce((searchValue) => {
                setSearchStr(searchValue);
                triggerLongLatP({ ZipCode: searchValue || null })
            }, 1000),
            []
        );

    useEffect(() => {
        if (adressConfirm === true) {
            formik.setFieldValue("primaryContactVMs.propertyAddress.addressLine1", formik?.values?.primaryContactVMs?.mailingAddress?.addressLine1)
            formik.setFieldValue("primaryContactVMs.propertyAddress.addressLine2", formik?.values?.primaryContactVMs?.mailingAddress?.addressLine2)
            formik.setFieldValue("primaryContactVMs.propertyAddress.zipCode", formik?.values?.primaryContactVMs?.mailingAddress?.zipCode)
            formik.setFieldValue("primaryContactVMs.propertyAddress.stateName", formik?.values?.primaryContactVMs?.mailingAddress?.stateName)
            formik.setFieldValue("primaryContactVMs.propertyAddress.cityName", formik?.values?.primaryContactVMs?.mailingAddress?.cityName)
            formik.setFieldValue("primaryContactVMs.propertyAddress.longitude", formik?.values?.primaryContactVMs?.mailingAddress?.longitude)
            formik.setFieldValue("primaryContactVMs.propertyAddress.latitude", formik?.values?.primaryContactVMs?.mailingAddress?.latitude)
        }
    }, [adressConfirm,formik.values])

    useEffect(() => {
        if (locationData && locationData?.result) {
            formik.setFieldValue(
                "primaryContactVMs.mailingAddress.stateName",
                locationData?.result?.state || ''
            );
            formik.setFieldValue(
                "primaryContactVMs.mailingAddress.cityName",
                locationData?.result?.city || ''
            );
        } 
    }, [locationData]);

    useEffect(() => {
        if (locationData2 && locationData2?.result ) {
            formik.setFieldValue("primaryContactVMs.propertyAddress.stateName", locationData2?.result?.state || '')
            formik.setFieldValue("primaryContactVMs.propertyAddress.cityName", locationData2?.result?.city || '')
        }
    }, [locationData2])


    
        useEffect(() => {
            if (longLatDataM && longLatDataM?.result) {
                formik.setFieldValue(
                    "primaryContactVMs.mailingAddress.latitude",
                    longLatDataM?.result?.latitude || ''
                );
                formik.setFieldValue(
                    "primaryContactVMs.mailingAddress.longitude",
                    longLatDataM?.result?.longitude || ''
                );
            }
        }, [longLatDataM]);
    
        useEffect(() => {
            if (longLatDataP && longLatDataP?.result) {
                formik.setFieldValue(
                    "primaryContactVMs.propertyAddress.latitude",
                    longLatDataP?.result?.latitude || ''
                );
                formik.setFieldValue(
                    "primaryContactVMs.propertyAddress.longitude",
                    longLatDataP?.result?.longitude || ''
                );
            }
        }, [longLatDataP]);

    return (
        <>
            <div className='row mt-2'>
                <h5>Mailing Address</h5>
                <div className="col-md-6">
                    <div className="form-wrap">
                        <TextField
                            label="Address line 1"
                            type="text"
                            required
                            value={formik.values?.primaryContactVMs?.mailingAddress?.addressLine1}
                            onChange={handleSearchLongLat1}
                        />
                    </div>
                    {/* {formik.touched.firstName && formik.errors.firstName && (
            <div className="error">{formik.errors.firstName}</div>
          )} */}
                </div>
                <div className="col-md-6">
                    <div className="form-wrap">
                        <TextField
                            label="Address Line 2 "
                            type="text"
                            {...formik.getFieldProps("primaryContactVMs.mailingAddress.addressLine2")}
                        // disabled={viewOnly}
                        />
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="form-wrap">
                        <TextField
                            label="ZipCode "
                            type="text"
                            required
                            value={formik.values.primaryContactVMs?.mailingAddress?.zipCode}
                            onChange={handleSearchChange1}
                        // {...formik.getFieldProps("primaryContactVMs.mailingAddress.zipCode")}
                        // disabled={viewOnly}
                        />
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="form-wrap">
                        <TextField
                            label="State/Region "
                            type="text"
                            required
                            disabled
                            value={locationData?.result?.state}
                            // onChange={() => formik.setFieldValue('primaryContactVMs.mailingAddress.stateName', locationData?.result?.state)}
                            {...formik.getFieldProps("primaryContactVMs.mailingAddress.stateName")}
                        // disabled={viewOnly}
                        />
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="form-wrap">
                        <TextField
                            label="City "
                            type="text"
                            required
                            value={locationData?.result?.city}
                            // onChange={() => formik.setFieldValue('primaryContactVMs.mailingAddress.stateName', locationData?.result?.city)}
                            {...formik.getFieldProps("primaryContactVMs.mailingAddress.cityName")}
                        // disabled={viewOnly}
                        />
                    </div>
                </div>
                <div className='col-md-3'>
                    <div className="form-wrap">
                        <TextField
                            label="Longitude "
                            type="text"
                            required
                            {...formik.getFieldProps("primaryContactVMs.mailingAddress.longitude")}
                            disabled
                        />
                    </div>
                </div>
                <div className='col-md-3'>
                    <div className="form-wrap">
                        <TextField
                            label="Latitude "
                            type="text"
                            required
                            {...formik.getFieldProps("primaryContactVMs.mailingAddress.latitude")}
                            disabled
                        />
                    </div>
                </div>


            </div>
            <div className="col-md-12 d-flex justify-content-end">
                <label className="input-label">
                    Property Address Same ?<span className="text-danger"> *</span>
                </label>
                <label className="checkboxs mt-2 mb-5">
                    <input
                        type="checkbox"
                        checked={adressConfirm}
                        onChange={
                            (e: any) => setAdressConfirm(e.target.checked)
                        }
                    // {...formik.getFieldProps("che")}
                    />
                    <span className="checkmarks" />
                </label>
            </div>
            {adressConfirm === false ?
                <div className='row mt-2'>
                    <h5>Property Address</h5>
                    <div className="col-md-6">
                        <div className="form-wrap">
                            <TextField
                                label="Address line 1"
                                type="text"
                                required
                                value={formik.values?.primaryContactVMs.propertyAddress.addressLine1}
                                onChange={handleSearchLongLat2}
                            />
                        </div>

                    </div>
                    <div className="col-md-6">
                        <div className="form-wrap">
                            <TextField
                                label="Address Line 2 "
                                type="text"
                                {...formik.getFieldProps("primaryContactVMs.propertyAddress.addressLine2")}
                            // disabled={viewOnly}
                            />
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="form-wrap">
                            <TextField
                                label="ZipCode "
                                type="text"
                                required
                                value={formik.values.primaryContactVMs?.propertyAddress?.zipCode}
                                onChange={handleSearchChange2}
                            // {...formik.getFieldProps("primaryContactVMs.propertyAddress.zipCode")}
                            // disabled={viewOnly}
                            />
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="form-wrap">
                            <TextField
                                label="State/Region "
                                type="text"
                                required
                                {...formik.getFieldProps("primaryContactVMs.propertyAddress.stateName")}
                                disabled
                            />
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="form-wrap">
                            <TextField
                                label="City "
                                type="text"
                                {...formik.getFieldProps("primaryContactVMs.propertyAddress.cityName")}
                                disabled
                            />
                        </div>
                    </div>
                    <div className='col-md-3'>
                        <div className="form-wrap">
                            <TextField
                                label="Longitude "
                                type="text"
                                required
                                {...formik.getFieldProps("primaryContactVMs.propertyAddress.longitude")}
                                disabled
                            />
                        </div>
                    </div>
                    <div className='col-md-3'>
                        <div className="form-wrap">
                            <TextField
                                label="Latitude "
                                type="text"
                                required
                                {...formik.getFieldProps("primaryContactVMs.propertyAddress.latitude")}
                                disabled
                            />
                        </div>
                    </div>

                </div>
                : ''}
        </>
    )
}

export default AddressesWizardData